module.exports = __webpack_public_path__ + "static/media/30.13bc61c8.jpg";